export class OptionLicense {
  public id: string | undefined;
  public tenant: string;
  public optionName: string;
  public active: boolean;

  constructor(data: any = {}) {
    this.id = data.id ?? undefined;
    this.tenant = data.tenant ?? undefined;
    this.optionName = data.optionName ?? undefined;
    this.active = data.active ?? undefined;
  }
}
